/**
 * Custom GlobalDropdownComponent - Override Component
 * Auto generated overrides from shared library
 */
import { Component, forwardRef } from '@angular/core';
import { SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatIconModule } from '@angular/material/icon';
import { GlobalDropdownComponent as ParentGlobalDropdownComponent } from '@shared-lib/global-components/global-dropdown/global-dropdown.component';

@Component({
  selector: 'app-global-dropdown',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTooltipModule,
    MatCheckboxModule,
    NgSelectModule,
    MatIconModule,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GlobalDropdownComponent),
      multi: true,
    },
  ],
  templateUrl: './global-dropdown.component.html',
  styleUrls: ['./global-dropdown.component.scss']
})
export class GlobalDropdownComponent extends ParentGlobalDropdownComponent {
  private readonly traceTag = '[GFLOW]';

  override ngOnChanges(_changes: SimpleChanges): void {
    this.filteredOptions = Array.isArray(this.options) ? [...this.options] : [];
    try {
      console.log(`${this.traceTag} DRP-${Date.now()}-${Math.random().toString(36).slice(2, 8)} dropdownOnChanges`, {
        key: this.data?.key,
        name: this.data?.name,
        optionsIn: this.options,
        filteredOptions: this.filteredOptions,
      });
    } catch (_e) {
      // ignore
    }
  }

  toCamelCaseDisplay(value: unknown): string {
    return this.formatDisplayLabel(value);
  }

  getSelectedSummary(items: unknown[] | null | undefined): string {
    if (!Array.isArray(items) || items.length === 0) {
      return '';
    }

    const firstLabel = this.formatDisplayLabel(items[0]);
    if (!firstLabel) {
      return '';
    }

    if (items.length <= 1) {
      return firstLabel;
    }

    return `${firstLabel} +${items.length - 1} more`;
  }

  formatDisplayLabel(value: unknown): string {
    if (value == null) {
      return '';
    }

    if (Array.isArray(value)) {
      const flattened = value
        .flat(Infinity)
        .map((item) => this.formatDisplayLabel(item))
        .filter((item) => !!item);
      return flattened[0] || '';
    }

    if (typeof value === 'string') {
      return value.trim();
    }

    if (typeof value === 'number' || typeof value === 'boolean') {
      return String(value);
    }

    if (typeof value === 'object') {
      const labelKeys = ['label', 'name', 'value', 'title', 'text', 'displayName'];
      for (const key of labelKeys) {
        const candidate = (value as Record<string, unknown>)[key];
        if (typeof candidate === 'string' && candidate.trim()) {
          return candidate.trim();
        }
      }

      try {
        const serialized = JSON.stringify(value);
        return serialized && serialized !== '{}' ? serialized : '';
      } catch (_error) {
        return '';
      }
    }

    return String(value).trim();
  }
}
